export const constant = {

  I18N_MESSAGES_FETCH_IN_PROGRESS: "I18N_MESSAGES_FETCH_IN_PROGRESS",
  I18N_MESSAGES_FETCH_COMPLETE: "I18N_MESSAGES_FETCH_COMPLETE",
}